import api from './api';

export const workspaceService = {
    list: () => api.get('/workspaces'),
    get: (id: string) => api.get(`/workspaces/${id}`),
    plugins: (id: string) => api.get(`/workspaces/${id}/plugins`),
    /** Owner saja (server menolak non-owner 403). Dipakai layar "Absensi belum aktif". */
    setPlugin: (id: string, key: string, enabled: boolean) =>
        api.patch(`/workspaces/${id}/plugins`, { key, enabled }),
};
